export default "__VITE_ASSET__BHIgk0rs__"